var mp = mp || {};

// Show/Hide widget
//-----------------------------------------------------------------
mp.accessibilityShowHide = function() {
    var $trigger = $(".accessibility-widget button");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.on('click', function(){
        $(this).next().toggleClass("show");
    });
};


// Store Accessibility Settings
//-----------------------------------------------------------------
mp.storeAccessibilitySettings = function() {
    var $form = $("#accessibility-form");
    var $element = $("#accessibility-form input");

    if (!$form.length) {
        return;
    }
    
    $element.on('click', function(){
        $.ajax({
            type: "POST",
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function(response) {
                mp.applyAccessibilitySettings();
            }
        });
    });
};


// Apply Accessibility Settings
//-----------------------------------------------------------------
mp.applyAccessibilitySettings = function() {
    $.ajax({
        type: "GET",
        url: "/handler/accessibility",
        success: function(response) {
            $response = jQuery.parseJSON(response);
            console.log($response);

            $('html').removeClass('accessibility--font-medium accessibility--font-large accessibility--brightness-dark accessibility--hyperlinks-underline');

            $.each($response, function(key,value) {
                if (value) {
                    $('html').addClass('accessibility--'+value);
                }
                $(".accessibility-widget input[value="+value+"]").prop("checked",true);
            });
        }
    });
};



$(document).ready(function (){
    mp.accessibilityShowHide();
    mp.storeAccessibilitySettings();
    mp.applyAccessibilitySettings();
});